
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './serviciosmttpp.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pserviciosmttpp = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6765e1301de4874021c20423" >

      <div id="iw4j" className="">
      
      <div id="iosy7m" className="">
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="iaiavt"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu70g5.png"
        alt="undefined"
      />
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/servicios"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>SERVICIOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/blog"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>ARTICULOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contactanos"
        type="button"
      >
        
    <div id="isq53" className="">
    <>CONTÁCTANOS</>
    </div>
    
      </a>
      
      </div>
      
      <div id="ibbry6" className="">
      
      </div>
      
      <div id="iacot" className="">
      
      <span className="material-icons " id="indcti">
        
      <span className="material-icons " id="izk84l">
        
      </span>
      
      </span>
      
        <a
          target="_blank"
          className=""
          id="isdo4d"
          href=""
        >
          
      <span className="material-icons " id="i3c93a">
        <>call</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="igbhjj"
          href=""
        >
          
      <span className="material-icons " id="iu387l">
        <>mail</>
      </span>
      
        </a>
        
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>INICIO</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <>SERVICIOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/articulos"
        type=""
      >
        <>ARTICULOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>CONTÁCTANOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
    <div id="" className="">
    
    </div>
    
      <div
        id="ixkyaq"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="ifeeku">
        <>¿Que es la terapia Healing Touch?</>
      </span>
      
      </div>
      
      <div id="iwm6zf" className="">
      
      </div>
      
      <div className="" id="i803s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      </div>
      
      <div className="" id="iqohul">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="iy5lyi">
        <>Healing Touch es una terapia energetica que limpia, balancea armoniza y nutre el campo fisico, mental, emocional y espiritual lo que promueve la autosanación en el paciente. Es una terapia recomendada para mujeres a lo largo de la vida adulta, porque apoya los cambios físicos y emocionales . Durante la menopausia, el duelo, ayuda a sobrellevar dolores crónicos y enfermedades degenerativos.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3dh" className="">
      
      <div id="ihp5j" className="">
      
      <div id="ivuade" className="">
      
      <div className="" id="i2tu9h">
        
      <span className="" id="ii6b7b">
        <>Modalidades de las sesiones:               A distancia y presenciales</>
      </span>
      
      </div>
      
      <div
        id="ist1uj"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="ivkiya" className="">
      
      <div id="i222rg" className="">
      
      <img
        className=""
        id="i300gf"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x9mw5f.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ig51ai" className="">
      
      <div className="" id="im7s5w">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ib2fo3">
        <>Conexión energética</>
      </span>
      
      </div>
      
      <div className="" id="io3916">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i7r6tb">
        <> Esta basado en que es  posible establecer una conexión energética entre la terapeuta y el paciente ,que permite la fluidez de la energía sanadora.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="iv8e2g"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="i1mmpy" className="">
      
      <div id="i0mza3" className="">
      
      <img
        className=""
        id="iv2egm"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x9mw5f.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="in60mn" className="">
      
      <div className="" id="i57mta">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iuho7r">
        <>Método utilizado</>
      </span>
      
      </div>
      
      <div className="" id="ijmvdn">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="is8tku">
        <> Seguir el protocolo de la terapia Healing  Touch , primero se realiza una entrevista, se hace un diagnostico del campo energético, se definen las metas  y se aplica la técnica energética .</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="iedg5a"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="ibua8z" className="">
      
      <div id="ijgv61" className="">
      
      <img
        className=""
        id="ioyylj"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x9mw5f.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iemfyw" className="">
      
      <div className="" id="i7cu4j">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="izbuji">
        <>Duración y frecuencia</>
      </span>
      
      </div>
      
      <div className="" id="io53tl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ivybsg">
        <> Se realiza una llamada o video llamada, que puede durar de 45 min a 1 hora. La frecuencia se define según el seguimiento especifico.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i25ski"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="idmb4w" className="">
      
      <div id="i20huu" className="">
      
      <img
        className=""
        id="iwe15l"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x9mw5f.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ia3gkk" className="">
      
      <div className="" id="i773yl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iesz2l">
        <>Preparación del paciente</>
      </span>
      
      </div>
      
      <div className="" id="i9ymjj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iplgy3">
        <> Se recomienda que la paciente se encuentre en un ambiente tranquilo, cómodo, recostada preferiblemente.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i2zu1z"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="itirjd" className="">
      
      <div id="ibg0wx" className="">
      
      <img
        className=""
        id="i7lead"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x9mw5f.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iwpcbf" className="">
      
      <div className="" id="ip9umj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="io4ocy">
        <>Ética</>
      </span>
      
      </div>
      
      <div className="" id="i8hewq">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i8yac2">
        <>La información personal y de salud se mantiene de manera confidencial. Se respeta la autonomía del paciente, en cualquier momento se puede interrumpir o detener la terapia. Limitaciones de la terapia)Es una terapia complementaria al tratamiento medico, no sustituye un tratamiento medico formal.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i4au78" className="">
      
      <div id="i98cnr" className="">
      
      <div className="" id="iua1xt">
        <>18+</>
      </div>
      
      <div className="" id="ig156l">
        <>Años Requeridos</>
      </div>
      
      </div>
      
      <img
        className=""
        id="iwh6b4"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x9r1g6.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div
        id="id80go"
        className=""
        data-aos="zoom-in-left"
        data-aos-duration="2000"
      >
      
      <div id="ifo3cg" className="">
      
      <div className="" id="i1tmsr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iptkxh">
        <>Aprende más de nosotros</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i0tfl" className="">
      
      <div id="i5a0dm" className="">
      
      <div
        id="i19x2j"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="2000"
      >
      
      <div id="ip3brm" className="">
      
      <img
        className=""
        id="if04gh"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x9y59q.png"
        alt="undefined"
      />
      
      <div className="" id="im1gxh">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ivucpb">
        <>Manejo del Duelo Perionatal</>
      </span>
      
      </div>
      
      <div className="" id="ib97lf">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i7xktz">
        <>La muerte de un bebe ya sea en el útero, o en los primeros días de vida es un evento muy difícil de procesar, se mueven muchas emociones y cambios en la madre. Muchas veces es un duelo no autorizado, y esto lo hace mas doloroso. El manejo del duelo perinatal, es un espacio sanador, en que se permite vivir las fases del duelo y procesar esta experiencia, para con amor y paciencia volver a retomar la vida.</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="i86oq4"
          href="#"
        >
          
      <div id="i5lsbi" className="">
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="if4hnc">
        <>Aprender Más</>
      </span>
      
      </div>
      
        </a>
        
      </div>
      
      </div>
      
      <div
        id="iztafm"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="2000"
      >
      
      <div id="ifqb06" className="">
      
      <img
        className=""
        id="ilsu8c"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x9y6n8.png"
        alt="undefined"
      />
      
      <div className="" id="ia91ax">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ic899g">
        <>Impacto en la comunidad</>
      </span>
      
      </div>
      
      <div className="" id="if0wdn">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ir969i">
        <>La terapia Healing Touch es un apoyo en procesos de crisis que se aplica a mujeres adultas, en diferentes etapas de sus vidas, como el duelo, la menopausia, la vejez, etc.  Permite un espacio empatico y de respeto en el que se puede expresar y soltar los miedos ante la enfermedad.</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="il5g8q"
          href="#"
        >
          
      <div id="ibj6i4" className="">
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5cu54">
        <>Aprender Más</>
      </span>
      
      </div>
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9f89n">
        <>Choloma, Cortes</>
      <br className="" id="" />
      <>Res. Bello Horizonte, Segunda etapa</>
      </span>
      
      </div>
      
      <div id="i3kbn4" className="">
      
        <a
          target="_blank"
          className=""
          id="ixsthl"
          href="#"
        >
          
      <img
        className=""
        id="iwpiyw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jbbv.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ikcig4"
          href="#"
        >
          
      <img
        className=""
        id="iv6mle"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jd5s.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="itq03p"
          href="#"
        >
          
      <img
        className=""
        id="isa627"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jfas.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ig3kxb"
          href="#"
        >
          
      <img
        className=""
        id="iqlafz"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jgsb.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="inpfp9"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu722a.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div id="i2vw8i" className="">
      
      </div>
      
      <div id="iabdji" className="">
      
      <div id="izci0t" className="">
      
      <div className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iubk6b">
        <>Copyrigt © 2024 </>
      </span>
      
      </div>
      
      <div className="" id="i4zwph">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ix41ho">
        <>Terapias Energéticas</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ip8opa" className="">
      
      <div className="" id="in8zl9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iytx9d">
        <>Términos y condiciones</>
      </span>
      
      </div>
      
      <div className="" id="ivyeul">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5zx35">
        <>Políticas de privacidad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pserviciosmttpp);
  